<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model.trim="code"
        clearable
        placeholder="请输入监管码"
        class="filter-item"
        @keyup.enter.native="getList"
        style="margin-right: 10px;width: 200px;"
      >
      </el-input>
      <el-input
        v-model.trim="artid"
        clearable
        placeholder="品种代号/品种名称/批号"
        class="filter-item"
        @keyup.enter.native="getList"
        style="margin-right: 10px;width: 200px;"
      >
      </el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      <el-button
        :loading="downloadLoading"
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        @click="handleDownload"
      >导出
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
       :max-height="clientHeight" 
      size="mini"
    >
      <el-table-column align="center" label="流水号" width="70">
        <template slot-scope="scope">{{ scope.row.bseqid }}</template>
      </el-table-column>
      <el-table-column align="center" label="品种编码" width="70">
        <template slot-scope="scope">{{ scope.row.artid }}</template>
      </el-table-column>
      <el-table-column label="品名" align="center" min-width="180" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="70">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column label="产家" align="center" min-width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="单位名称" align="center" width="200">
        <template slot-scope="scope">{{ scope.row.custname }}</template>
      </el-table-column>
       <el-table-column label="数量" align="center" width="70">
        <template slot-scope="scope">{{ scope.row.total }}</template>
      </el-table-column>
       <el-table-column label="金额" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.amount }}</template>
      </el-table-column>
       <el-table-column label="监管码" align="center" width="70">
        <template slot-scope="scope">{{ scope.row.code }}</template>
      </el-table-column>
      <el-table-column label="批号" align="center" width="70">
        <template slot-scope="scope">{{ scope.row.serial }}</template>
      </el-table-column>
       <el-table-column label="业务员ID" align="center" width="70">
        <template slot-scope="scope">{{ scope.row.userid }}</template>
      </el-table-column>
       <el-table-column label="业务员" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.username }}</template>
      </el-table-column>
       <el-table-column label="单位代码" align="center" width="70">
        <template slot-scope="scope">{{ scope.row.customerid }}</template>
      </el-table-column>
      
    </el-table>

    <!--&lt;!&ndash;分页&ndash;&gt;-->
    <!--<pagination-->
    <!--:total="total"-->
    <!--:page.sync="listQuery.page"-->
    <!--:limit.sync="listQuery.limit"-->
    <!--@pagination="getList"-->
    <!--&gt;-->
    <!--</pagination>-->
  </div>
</template>

<script>
import { getDzjgm } from '@/api/flow'
// import Pagination from '@/components/Pagination'

export default {
  name: 'ProductInfo',

  // components: {
  //   Pagination
  // },

  data() {
    return {
      clientHeight: '800',
      list: null,
      code: '',
      artid: '',
      listLoading: false,
      downloadLoading: false,
    }
  },

  created() {
    this.initHeight()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },

    getList() {
      this.list = []
      if (this.code !== '' || this.artid !=='') {
        this.listLoading = true
        getDzjgm(this.code,this.artid)
          .then(response => {
            this.list = response.data
            this.listLoading = false
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
      }
    },
    // 格式化数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    },
    // 导出事件
    handleDownload() {
      this.downloadLoading = true
      getDzjgm(this.code,this.artid).then(response => {
        this.allList = response.data
        import('@/vendor/Export2Excel')
          .then(excel => {
          
            const tHeader = [
              '流水号',
              '品种编码',
              '品名',
              '规格',
              '单位',
              '产家',
              '单位名称',
              '数量',
              '金额',
              '监管码',
              '批号',
              '业务员ID',
              '业务员',
              '单位代码'
            ]
            const filterVal = [
              'bseqid',
              'artid',
              'name',
              'spec',
              'unit',
              'factory',
              'custname',
              'total',
              'amount',
              'code',
              'serial',
              'userid',
              'username',
              'customerid'
            ]
             debugger;
            const data = this.formatJson(filterVal, this.allList)
           
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '监管码'
            })
            this.downloadLoading = false
          })
          .catch(() => {
            this.downloadLoading = false
          })
      })
    }
  }
}
</script>
